import React, { PureComponent } from 'react';
// eslint-disable-next-line import/extensions
import yaml from 'js-yaml';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Col, Row } from 'reactstrap';
import NFButton from '../../primitives/NFButton';
import { sendInvitation } from '../../../pages/Invitation/Invitation';

class ViewInvitation extends PureComponent {
  static propTypes = {
    item: PropTypes.any.isRequired,
    showViewModal: PropTypes.bool.isRequired,
    closeViewModal: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  render() {
    const { showViewModal, closeViewModal, item, onUpdate } = this.props;
    const {
      name,
      address1,
      address2,
      city,
      state,
      zipCode,
      cntry,
      pointOfContact,
      email,
      phoneNumber,
      websiteUrl,
      iconStatus,
      industryType,
      naics,
      associationValidations,
      associationChanges,
      cageCode,
      inviteDate,
      claimDate,
      requestDate,
      deniedDate,
      approvalDate,
      SAM,
      capabilities,
      updated,
    } = item || {};

    const associations = {}
    if (associationValidations) {
      associationValidations.forEach(a => {
        const ax = { ...a }
        delete ax.name;
        associations[a.name] = ax;
      });
    }

    const changes = {}
    if (associationChanges) {
      associationChanges.forEach(a => {
        const ax = { ...a };
        delete ax.name;
        delete ax.lastRead;
        if (Object.keys(ax).length) {
          changes[a.name] = ax;
        }
      });
    }

    const company = {
      name,
      address1,
      address2,
      city,
      state,
      zipCode,
      cntry,
      pointOfContact,
      email,
      phoneNumber,
      websiteUrl,
      naics: naics && naics.length && naics[0],
      cageCode,
      industryType: industryType && industryType.length && industryType[0],
      iconStatus: iconStatus || (inviteDate ? 'invited' : undefined),
      inviteDate,
      claimDate,
      requestDate,
      deniedDate,
      approvalDate,
      SAM,
      updated,
      associations
    };

    return (
      <div className="nf-add-organization">
        <Modal
          title={<h2>{name}</h2>}
          visible={showViewModal}
          width="fit-content"
          footer={null}
          onCancel={closeViewModal}
        >
          <Row>
            <Col>
              <h4>Company Information</h4>
              <TextArea
                rows={25}
                cols={60}
                value={yaml.dump(company, { indent: 4, lineWidth: -1 })}
              />
            </Col>
            <Col>
              <h4>Capabilities</h4>
              <TextArea
                rows={25}
                cols={60}
                value={yaml.dump(capabilities, { indent: 4, lineWidth: -1 })}
              />
            </Col>
            <Col>
              <h4>Changes</h4>
              <TextArea
                rows={25}
                cols={60}
                value={yaml.dump(changes, { indent: 4, lineWidth: -1 })}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col sm={{ size: 7, offset: 5 }} className="text-center">
              <NFButton
                className="nf-button--gray-border"
                onClick={() => {
                  closeViewModal();
                }}
              >
                Cancel{' '}
              </NFButton>
              &nbsp;&nbsp;&nbsp;
              <NFButton
                className="nf-button--form nf-button--orange"
                type="submit"
                onClick={async () => {
                  const data = await sendInvitation(item);
                  onUpdate(data);
                  closeViewModal();
                }}
              >
                {iconStatus === 'approved' || iconStatus === 'Approved' ? 'Sync' : (iconStatus || inviteDate ? 'Update' : 'Invite')}
              </NFButton>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

export default ViewInvitation;



// WEBPACK FOOTER //
// ./src/components/Modals/ViewInvitation/ViewInvitation.jsx